module.exports = __webpack_public_path__ + "img/react-phantom-run-flyknit-2-mens-running-shoe.34ea1f4b.png";